module.exports = __webpack_public_path__ + "img/greater_earth_elemental_small.ce6c79bf.png";